/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementScholarshipItemViewModel } from "../types/CourseRegistrationManagementScholarshipItemViewModel.ts";
import { eScholarshipStatusSchema } from "./eScholarshipStatusSchema.ts";

export const courseRegistrationManagementScholarshipItemViewModelSchema =
  z.object({
    courseFinancialPersonId: z.optional(
      z
        .number()
        .int()
        .describe("ID do plano financeiro pessoal associado à bolsa."),
    ),
    courseFinancialDescription: z
      .string()
      .describe("Descrição do plano financeiro.")
      .nullish(),
    scholarshipTypeId: z
      .number()
      .int()
      .describe("ID do tipo de bolsa. Opcional.")
      .nullish(),
    scholarshipTypeDescription: z
      .string()
      .describe("Descrição do tipo de bolsa. Opcional.")
      .nullish(),
    scholarshipStatus: z.optional(
      z
        .lazy(() => eScholarshipStatusSchema)
        .describe(
          "1 = Interested | 2 = InProcess | 3 = ScholarshipHolder | 4 = Refused | 5 = RefusedInterested | 6 = RefusedPotential | ",
        ),
    ),
    scholarshipStatusDescription: z
      .string()
      .describe("Descrição textual do status da bolsa. Opcional.")
      .nullish(),
    schoolDiscount: z
      .number()
      .describe("Percentual de desconto escolar aplicado via bolsa. Opcional.")
      .nullish(),
    scholarshipReason: z
      .string()
      .describe("Motivo pelo qual a bolsa foi concedida. Opcional.")
      .nullish(),
  }) as unknown as ToZod<CourseRegistrationManagementScholarshipItemViewModel>;
